import { Badge, Button, Card, FeedbackText, Text } from '@cascade/ui-library';
import classes from './SummaryAction.module.scss';
import type {
  TSummaryActionProps,
  TSummaryActionStatus,
} from './SummaryAction.types.ts';

const statusLooks = {
  idle: { cardVariant: 'default', badgeVariant: 'brand-darker' },
  pending: { cardVariant: 'default', badgeVariant: 'brand-darker' },
  done: { cardVariant: 'success', badgeVariant: 'success-darker' },
  failed: { cardVariant: 'danger', badgeVariant: 'danger-darker' },
} as const satisfies Record<TSummaryActionStatus, unknown>;

export const SummaryAction = ({
  iconType,
  title,
  description,
  status,
  actionLabel,
  errorMessage,
  isDisabled,
  onAction,
}: TSummaryActionProps) => {
  const { cardVariant, badgeVariant } = statusLooks[status];
  const isDone = status === 'done';
  const isFailed = status === 'failed';

  return (
    <Card
      variant={cardVariant}
      fillVariant={cardVariant !== 'default'}
      padding='md'
      borderRadius='md'
    >
      <div className={classes['summary-action']}>
        <Badge
          label={title}
          iconType={isDone ? 'check' : iconType}
          variant={badgeVariant}
          size='lg'
          iconOnly
        />
        <div className={classes.text}>
          <Text type='h6' weight='semibold' content={title} compact />
          <Text type='caption' color='text-60' content={description} />
          <FeedbackText
            feedbackLevel='danger'
            feedbackText={isFailed ? errorMessage : undefined}
          />
        </div>
        <div className={classes.action}>
          <Button
            size='sm'
            iconType={isFailed ? 'rotate-right' : iconType}
            label={actionLabel}
            disabled={isDisabled}
            onClick={onAction}
          />
        </div>
      </div>
    </Card>
  );
};
